import React from 'react'
import { Grid, Paper, Button, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { ArcGauge } from '@progress/kendo-react-gauges'
import { FileDocument } from 'mdi-material-ui'
import { Tab } from '@material-ui/icons'
import styles from '../styles'
import classNames from 'classnames'
import {
  azSelector,
  zaSelector,
  oldestFirstSelector,
  newestFirstSelector,
} from 'selectors'
import DeleteMenu from './DeleteMenu'

export default withRouter(
  connect(
    state => ({
      forms: state.signupForm.forms,
      az: azSelector(state),
      za: zaSelector(state),
      oldestFirst: oldestFirstSelector(state),
      newestFirst: newestFirstSelector(state),
      sort: state.signupForm.sort,
    }),
    null
  )(
    withStyles(styles)(
      ({ classes, forms, az, za, oldestFirst, newestFirst, sort, history }) => {
        const sorted = { az, za, oldestFirst, newestFirst }
        return (
          <Grid container spacing={24}>
            {sorted[sort].map(form => {
              const date = new Date(form.when_created)
              return (
                <Grid key={`formTile-${form.id}`} item sm={12} md={6} lg={4}>
                  <Paper className={classes.tile}>
                    <Grid container spacing={24}>
                      <Grid item xs={12}>
                        <Typography className={classes.dataPanelTitle}>
                          {form.name}
                        </Typography>
                      </Grid>
                      <Grid className={classes.dataPanelSection} item xs={6}>
                        <h5 style={{ margin: '38px 0 0' }}>
                          {`${form.stats ? form.stats.visits : 0}`}
                          <br />
                          {`Visit${
                            !form.stats || form.stats.visits !== 1 ? 's' : ''
                          }`}
                        </h5>
                      </Grid>
                      <Grid className={classes.dataPanelSection} item xs={6}>
                        <ArcGauge
                          style={{ width: '100%', height: '100%' }}
                          value={0}
                          arcCenterRender={() => (
                            <h5 style={{ margin: '10px 0 0' }}>
                              {`${
                                form.stats && form.stats.visits > 0
                                  ? Math.round(
                                      (form.stats.submissions /
                                        form.stats.visits) *
                                        100
                                    )
                                  : '--'
                              }%`}
                              <br />
                              Responded
                            </h5>
                          )}
                        />
                      </Grid>
                      <Grid
                        className={classes.dataPanelEmailSection}
                        item
                        xs={12}
                      >
                        <div style={{ height: 75, overflowY: 'auto' }}>
                          {form.signups ? (
                            form.signups.map((signup, idx) => (
                              <div
                                style={{
                                  backgroundColor:
                                    idx % 2 === 0 ? '#ECE4F5' : '#FAF8FD',
                                  padding: '3px',
                                }}
                                key={`formPageTileResponse${idx}`}
                              >
                                {signup.contact_method}
                              </div>
                            ))
                          ) : (
                            <div
                              style={{
                                textAlign: 'center',
                                paddingTop: '25px',
                                paddingBottom: '0',
                                marginBottom: '-18px',
                              }}
                            >
                              No responses yet
                            </div>
                          )}
                        </div>
                      </Grid>
                      <Grid className={classes.dataPanelSection} item xs={12}>
                        <Button
                          onClick={() => history.push(`forms/${form.id}`)}
                          className={classes.dataPanelButton}
                        >
                          [read more]
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        {form.display_type === 'popover' ? (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Tab
                              className={classNames(
                                classes.leftIcon,
                                classes.secondary
                              )}
                            />
                            <span
                              style={{ fontSize: '12px', fontWeight: 'bold' }}
                            >
                              Popover Form
                            </span>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <FileDocument
                              className={classNames(
                                classes.leftIcon,
                                classes.secondary
                              )}
                            />
                            <span
                              style={{ fontSize: '12px', fontWeight: 'bold' }}
                            >
                              Embedded Form
                            </span>
                          </div>
                        )}
                      </Grid>
                      <Grid className={classes.dataPanelSection} item xs={6}>
                        <div style={{ fontSize: '12px', fontWeight: 'bold' }}>
                          Created:{' '}
                          <span
                            className={classes.secondary}
                          >{`${date.toLocaleDateString()}`}</span>
                        </div>
                      </Grid>
                    </Grid>
                    <DeleteMenu history={history} formID={form.id} vert />
                  </Paper>
                </Grid>
              )
            })}
          </Grid>
        )
      }
    )
  )
)
